import { SpellcheckSharp } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import AppSelect from '../components/AppInput/AppSelect'

function SpeechConfig() {
    const [voiceList,setVoiceList]  = useState(null);

    const getVoiceList = async () =>{
        let _voices = speechSynthesis.getVoices();
        let _voiceList = [];
        _voices.forEach((voice,i)=>{
            _voiceList.push({value:i,label:voice.voiceURI+" - "+voice.lang})
        })
        setVoiceList(_voiceList)
        if(voiceIndex == null){
            setVoiceIndex(sessionStorage.getItem("voiceIndex"))
        }
    }

    useEffect(()=>{
        getVoiceList()
    },[])


    const [voiceIndex,setVoiceIndex]  = useState(null)
    const [selectedVoice,setSelectedVoice] = useState(null)

    useEffect(()=>{
        if(selectedVoice!==null){
            sessionStorage.setItem("voiceIndex",selectedVoice.value)
            setVoiceIndex(selectedVoice.value)
        }
    },[selectedVoice])

    const speak = (text) =>{
        var uttr = new SpeechSynthesisUtterance();
        uttr.text = text;
        console.log(speechSynthesis.getVoices())
        uttr.voice = speechSynthesis.getVoices()[voiceIndex];
        speechSynthesis.speak(uttr)
        //messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }


    return (
        <div className="row pb-3">
            {voiceIndex == null ?
            <div className="col-12">
                {voiceList &&
                <AppSelect
                    options={voiceList}
                    value={selectedVoice}
                    setValue={setSelectedVoice}
                    label="Select Language"
                    optionLavel="label"
                />}
            </div>
            :
            <div className="col-12">
                {voiceList &&
                    <div className="d-flex justify-content-enter" >
                        <h4 className="text-warning bg-dark p-2 rounded">Selected Voice : {voiceList[voiceIndex]?.label}</h4>
                        <span>
                            <button className="btn btn-warning ms-2 mt-1" onClick={()=>setVoiceIndex(null)} >Change</button>
                            <button className="btn btn-danger ms-2 mt-1" onClick={()=>speak("Hello Daini This is a test message")}>Test Voice</button>
                        </span>
                    </div>
                }
            </div>
            }
        </div>
    )
}

export default SpeechConfig